module.exports = __webpack_public_path__ + "img/img_size5_test.cea2faba.png";